import {
  TutorialJourneyProfileDto,
  UpdateTutorialJourneyCommand,
  ITutorialJourneysViewModel,
} from "@growth-machine-llc/stridist-api-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import TutorialJourneyProfilesService from "../../../services/TutorialJourneyProfilesService";
import { TUTORIAL_PROFILES_QUERY_KEY } from "../journey/TutorialJourneysList";

export function useUpdateTutorialJourneyProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateTutorialJourneyCommand) =>
      TutorialJourneyProfilesService.updateTutorialJourneyProfile(payload),
    onSuccess: (_, payload) => {
      queryClient.setQueryData<ITutorialJourneysViewModel>(
        [TUTORIAL_PROFILES_QUERY_KEY],
        (oldData) => {
          const previousData = oldData || { profiles: [], journeys: [] };

          const updatedProfiles = previousData.profiles.map((profile) =>
            profile.id === payload.id
              ? new TutorialJourneyProfileDto({ ...profile, ...payload })
              : profile,
          );

          return {
            ...previousData,
            profiles: updatedProfiles,
          };
        },
      );

      queryClient.invalidateQueries({
        queryKey: [TUTORIAL_PROFILES_QUERY_KEY],
      });
    },
  });
}
